export const FETCH_CATEGORIES = 'ACCOUNTS_MARKETPLACE/FETCH_CATEGORIES'
export const SET_FILTERS = 'ACCOUNTS_MARKETPLACE/SET_FILTERS'
export const SET_CATEGORIES = 'ACCOUNTS_MARKETPLACE/SET_CATEGORIES'
export const SET_LOADING = 'ACCOUNTS_MARKETPLACE/SET_LOADING'
export const DROP_DATA = 'ACCOUNTS_MARKETPLACE/DROP_DATA'
